import React from 'react'
import { Slot } from '@radix-ui/react-slot'
import { cn } from '@/lib/utils'

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'default' | 'ghost' | 'outline' | 'destructive'
  size?: 'default' | 'sm' | 'lg'
  asChild?: boolean
}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant = 'default', size = 'default', asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : 'button'
    return (
      <Comp
        className={cn(
          'inline-flex items-center justify-center gap-2 rounded-md text-sm font-medium transition-colors',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--primary)]',
          'disabled:pointer-events-none disabled:opacity-50',
          variant === 'default' &&
            'bg-[var(--primary)] text-white hover:bg-[var(--primary-hover)]',
          variant === 'ghost' &&
            'hover:bg-[var(--bg-elevated)] hover:text-[var(--fg)]',
          variant === 'outline' &&
            'border border-[var(--border)] bg-transparent hover:bg-[var(--bg-elevated)]',
          variant === 'destructive' &&
            'bg-red-500 text-white hover:bg-red-600',
          size === 'default' && 'h-10 px-4 py-2',
          size === 'sm' && 'h-8 px-3 text-xs',
          size === 'lg' && 'h-12 px-6',
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)

Button.displayName = 'Button'
